import { Injectable } from '@angular/core';

@Injectable()
export class AuthService {

  constructor() { }

}



// WEBPACK FOOTER //
// ./src/app/auth.service.ts